import React, { useState } from 'react';
import './HamburgerMenu.css';

export default function HamburgerMenu({ onEditProfile, onViewPokes, onSettings, onSignOut, unreadPokes = 0 }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOption = (callback) => {
    setIsOpen(false);
    callback();
  };

  return (
    <>
      <button 
        className="hamburger-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu"
      >
        {unreadPokes > 0 && <span className="notification-badge">{unreadPokes}</span>}
        <div className={`hamburger ${isOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {isOpen && (
        <>
          <div className="menu-overlay" onClick={() => setIsOpen(false)} />
          <div className="menu-dropdown">
            <button onClick={() => handleOption(onViewPokes)}>
              pokes {unreadPokes > 0 && <span className="badge">{unreadPokes}</span>}
            </button>
            <button onClick={() => handleOption(onEditProfile)}>
              edit profile
            </button>
            <button onClick={() => handleOption(onSettings)}>
              settings
            </button>
            <button onClick={() => handleOption(onSignOut)} className="sign-out">
              sign out
            </button>
          </div>
        </>
      )}
    </>
  );
}